import { Inject, Injectable } from '@angular/core';
import { AUTH_REPOSITORY, AuthRepository } from '@app/core/repositories/auth.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    @Inject(AUTH_REPOSITORY)
    protected repository: AuthRepository
  ) {}

  logout(): Observable<any> {
    return this.repository.logout();
  }
}
